module.exports = __webpack_public_path__ + "static/media/Poudre-DINING-ROOM-TO-KITCHEN.7890c925.jpg";